// extracted by mini-css-extract-plugin
export default {"wrapper":"PurchaseBusinessPage_wrapper__Z90PP","content_wrapper":"PurchaseBusinessPage_content_wrapper__ukHwx","content":"PurchaseBusinessPage_content__ktNcL"};